import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'extra-features',
  templateUrl: './extra-features.component.html',
  styleUrls: ['./extra-features.component.scss']
})
export class ExtraFeaturesComponent {}
